import { Theme } from "@mui/material";
import { green } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
export const useLgStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "100vh",
    width: "100%",
    position: "relative",
  },
  main: {
    display: "flex",
    justifyContent: "space-around",
    height: "100vh",
  },
  welcomToText: {
    fontWeight: 600,
    fontSize: 56,
    lineHeight: "65px",
    color: "#EDAC15",
  },
  MedicalCareText: {
    fontWeight: "400",
    fontSize: "26px",
    lineHeight: "140%",
    color: "#2A3333",
    fontFamily: theme.typography.fontFamily,
    fontStyle: "Regular",
    verticalAlign: "top",
    width: "auto",
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  subText: {
    fontSize: 18,
    fontWeight: 400,
  },
  copyRightText: {
    position: "absolute",
    bottom: 15,
    fontSize: 14,
    color: "#00000062",
    left: "50%",
    transform: "translate(-50%, 0)",
  },
  right: {
    background: "#F5F8FF",
    padding: "26px 40px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  leftMain: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    backgroundColor: "#fff",
  },
  left: {
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    width: "100%",
    padding: "0 24px",
  },
  loginButtonWrapper: {
    position: "relative",
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    background: "#3D63E6",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  logo: {
    position: "absolute",
    left: 40,
    top: 50,
  },
  loginTexts: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
  },
  form: {
    display: "flex",
    alignSelf: "center",
    width: "20%",
    background: "#D1D1D1",
  },
  error: {
    width: "100%",
    textAlign: "center",
    justifyContent: "center",
    marginBottom: 10,
  },
  keepSignedin: {
    marginTop: 26,
  },
  submit: {
    marginTop: 26,
    width: "100%",
    height: 56,
    fontSize: 22,
    fontWeight: 500,
    borderRadius: 5,
  },
  languageSwitch: {
    position: "absolute",
    top: "10px",
    right: "10px",
  },
  email: {
    marginTop: 0,
    marginBottom: 23,
    borderRadius: 5,
  },
  password: {
    margin: 0,
    borderRadius: 5,
  },
  labelKeepSignedIn: {
    fontSize: 16,
    fontWeight: 400,
  },
  wrapper: {
    position: "relative",
  },
  phoneIcon: {
    position: "absolute",
    top: -18,
    right: -45,
  },
  backToLogin: {
    fontSize: 18,
    color: "#FF923D",
    marginTop: 10,
  },
  image: {
    width: "inherit",
    height: "100vh",
  },
}));
